var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/splash.jpg"),"alt":"Hothead Factory"}}),_vm._v(" "),_c('services'),_vm._v(" "),_c('button-combo'),_vm._v(" "),_c('copyright')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fb24fc4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage/Index.vue
// module id = null
// module chunks = 